import { ThemeUIStyleObject } from "theme-ui"

export const BackgroundVideoStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden",
  ".lazyload-wrapper": {
    height: "100%",
  },
}
export const VideoStyles: ThemeUIStyleObject = {
  display: "block",
  alignSelf: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translateX(-50%) translateY(-50%)",
  minWidth: "100%",
  minHeight: "100%",
  width: "auto",
  height: "auto",
}

export const ContentWrapperStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: "0",
  width: "100%",
  height: "100%",
  zIndex: "2",
  overflow: "hidden",
}
